import i18n from './i18n';
export default {
  required: value => !!value || i18n.t('validation.field_is_required'),
  exact_length: length => {
    return function (value) {
      if (value && value.length != length) {
        return 'Field should be of at least ' + length + ' characters';
      }
      return true;
    };
  },
  min_length: length => {
    return function (value) {
      if (value && value.length < length) {
        return i18n.t('me.validation.min_length', {length: length});
      }
      return true;
    };
  },
  email: value => {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test (value) || 'invalid email';
  },
  isValidPhone: value => {
    let regex = /^[0-9]*$/;
    return regex.test (value) || 'Field should contain only numbers';
  },
  englishCharacters: value => {
    const pattern = /^[ A-Za-z0-9_@./#&+-]*$/;
    return (
      pattern.test (value) ||
      'Only alphanumeric and special characters are allowed '
    );
  },
  alphaNumericCharacters: value => {
    const pattern = /^[a-zA-Z0-9]+$/;
    return (
      pattern.test (value) ||
      'Only alphanumeric characters are allowed'
    );
  },
  max_length: length => {
    return function (value) {
      if (value && value.length > length) {
        return i18n.t ('rms.validation.max_length', {length: length});
      }
      return true;
    };
  },
};
